import * as yup from "yup";
import constant from "lib/constant/constant";

const newPasswordSchema = (cms) =>
  yup.object().shape({
    newPassword: yup
      .string()
      .required(cms("common.message.error.passwordIsRequired"))
      .matches(/.{8,}/, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(/[^A-Za-z0-9]/, "Password must contain at least one special character"),
  });
const confirmationPasswordSchema = (cms) =>
  yup.object().shape({
    confirmationPassword: yup
      .string()
      .required(cms("common.message.error.confirmPasswordIsRequired"))
      .oneOf([yup.ref(constant.NEW_PASSWORD), null], cms("common.message.error.confirmPasswordMatch")),
  });

export { newPasswordSchema, confirmationPasswordSchema };
